"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function MetaformFieldFlagsFromJSON(json) {
    return MetaformFieldFlagsFromJSONTyped(json, false);
}
exports.MetaformFieldFlagsFromJSON = MetaformFieldFlagsFromJSON;
function MetaformFieldFlagsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'managementEditable': !runtime_1.exists(json, 'managementEditable') ? undefined : json['managementEditable'],
    };
}
exports.MetaformFieldFlagsFromJSONTyped = MetaformFieldFlagsFromJSONTyped;
function MetaformFieldFlagsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'managementEditable': value.managementEditable,
    };
}
exports.MetaformFieldFlagsToJSON = MetaformFieldFlagsToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1GaWVsZEZsYWdzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2dlbmVyYXRlZC9jbGllbnQvbW9kZWxzL01ldGFmb3JtRmllbGRGbGFncy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0JBQW9CO0FBQ3BCLG9CQUFvQjtBQUNwQjs7Ozs7Ozs7OztHQVVHOztBQUVILHdDQUErQztBQWUvQyxTQUFnQiwwQkFBMEIsQ0FBQyxJQUFTO0lBQ2hELE9BQU8sK0JBQStCLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0FBQ3hELENBQUM7QUFGRCxnRUFFQztBQUVELFNBQWdCLCtCQUErQixDQUFDLElBQVMsRUFBRSxtQkFBNEI7SUFDbkYsSUFBSSxDQUFDLElBQUksS0FBSyxTQUFTLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsRUFBRTtRQUN6QyxPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILG9CQUFvQixFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsb0JBQW9CLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsb0JBQW9CLENBQUM7S0FDckcsQ0FBQztBQUNOLENBQUM7QUFSRCwwRUFRQztBQUVELFNBQWdCLHdCQUF3QixDQUFDLEtBQWlDO0lBQ3RFLElBQUksS0FBSyxLQUFLLFNBQVMsRUFBRTtRQUNyQixPQUFPLFNBQVMsQ0FBQztLQUNwQjtJQUNELElBQUksS0FBSyxLQUFLLElBQUksRUFBRTtRQUNoQixPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILG9CQUFvQixFQUFFLEtBQUssQ0FBQyxrQkFBa0I7S0FDakQsQ0FBQztBQUNOLENBQUM7QUFYRCw0REFXQyJ9